var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"header-title-two"},[_c('v-col',[_c('v-skeleton-loader',{class:( _obj = { 'header-loading-2': true }, _obj[_vm.loaderClass] = _vm.loaderClass && _vm.loading, _obj ),attrs:{"loading":_vm.loading,"type":"heading"}},[_c('h1',{staticClass:"text-sm-12"},[_vm._v(_vm._s(_vm.title))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }